import React from 'react';

const JobsPageConfig: any = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/home/jobs',
			exact: true,
			component: React.lazy(() => import('./JobsPage')),
		},
	],
};

export default JobsPageConfig;
